<template>
  <div class="comp-ly-detail">
    <jw-drawer
      ref="drawerRef"
      :style="{ width: data.drawerWidth, left: 'auto', height: '100%' }"
      :mask="false"
      width="100%"
      :visible="data.visible"
      @cancel="handleCancel"
      @before-close="handleCancel"
      unmount-on-close
      :footer="false"
      :header="false"
      :drawer-style="{
        backgroundColor: 'var(--color-fill-2)',
        boxShadow: '0 1px 3px rgba(0,0,0,.3)'
      }"
      class="obj-details-drawer"
    >
      <div class="custom-mask" v-if="mask && !layoutDetailLoading" @click="closeDialog(false)"></div>
      <div v-if="layoutDetailLoading" class="details-loading">
        <jw-spin :tip="$t('加载中') + '……'" />
      </div>
      <div v-else class="drawer-min-width">
        <template v-if="data.record?.length && !isDeleted">
          <fh-header :entity="data.entity" @cb="handleHeaderCb" :viewId="data.viewId" :tabIndex="data.initKey" :computedErrorTooltipContent="computedErrorTooltipContent" :loading="data.smallLoading || computedErrorStatus">
            <template #objName>
              <div v-if="showHeadTitle" class="obj-name-content">
                <jw-tag v-if="objectTitle" class="object_title" size="medium" color="blue">{{ objectTitle }}</jw-tag>
                <xl-label-text :value="data.detailsTitle" :row="1" />
              </div>
            </template>

            <template #button>
              <!-- :buttons="buttons"  :entity="data.entity" -->
              <fh-buttons v-if="isComputedRequested" :computedError="computedError" :detailAllFields="data.detailAllFields" :buttonNum="buttonNumber" :allButtonsList="allButtonsList" :entity="data.entity" @cb="buttonsEvent"></fh-buttons>
            </template>
          </fh-header>
          <div class="detail-drawer-content">
            <div :class="['main-detail', !expandCollapse ? 'large-content' : '']">
              <abstract-skeleton v-if="data.abstractLoading" />
              <!-- <ly-skeleton v-if="data.abstractLoading" :lineHeight="26" :row="3"></ly-skeleton> -->
              <template v-else>
                <div class="main-title-box" ref="mainTitleRef">
                  <main-title :title="data.detailsTitle" :objectTitle="objectTitle" @handleExpand="handleExpand" />
                </div>
                <template v-if="data.abstractList?.length">
                  <fh-abstract :record="data.abstractList"></fh-abstract>
                </template>
              </template>
              <template v-if="layoutAllFields?.hasOppStage">
                <!-- 商机阶段 S-->
                <opportunity-stage ref="opStageRef" :detailAllFields="data.detailAllFields" @cb="detailRefresh"></opportunity-stage>
                <!-- 商机阶段 E-->
              </template>
              <!-- 阶段流程推进器 -->
              <xl-flow-stage v-else ref="flowStageRef" :detailData="data" class="flow-stage-content"></xl-flow-stage>
              <jw-card class="layout-tab-area-no-flow-stage" :bordered="false">
                <div class="tab-box">
                  <xl-tabs ref="tabsRef" @selectTab="changeTab" :tabs="data.tabList?.modules?.filter((fItem) => fItem.display == 1)" :field-name="{ title: 'label', key: 'id' }" :defaultActive="defaultActive" :key="expandCollapse" />
                </div>
                <jw-tabs :active-key="data.initKey" :default-active-key="0" @change="switchTabs" lazy-load destroy-on-hide>
                  <jw-tab-pane v-for="(item, index) in data.tabList?.modules" :key="index">
                    <template #title></template>
                    <!-------------------- 公共页签 S ------------------------->
                    <div class="tab-detail" v-if="showTabPart(item.value)">
                      <!-- 【审批记录】所有对象都有此页签 -->
                      <template v-if="item.value == 'approvalRecord'">
                        <approve-record :moduleId="item.id"></approve-record>
                      </template>

                      <!-- 【资料沉淀】：客户、商机、合同、售后服务 -->

                      <template v-if="item.value == 'cloud'">
                        <xl-cloud-document :moduleId="item.id" @cb="updateStage"></xl-cloud-document>
                      </template>

                      <!-- 【资料沉淀】：客户、商机、合同、售后服务 -->
                      <!--【联系人】【通话记录】【日程】线索、客户、商机 公共页签 S-->
                      <template v-if="item.value == 'linkMan'">
                        <xl-contacts :moduleId="item.id"></xl-contacts>
                      </template>
                      <template v-if="item.value == 'callRecord'">
                        <xl-calllog :moduleId="item.id"></xl-calllog>
                      </template>

                      <template v-if="item.value == 'schedule'">
                        <xl-schedule :moduleId="item.id" :followRecordIsShow="followRecordIsShow" @cbx="refreshFollowList" ref="calendarTripRef"></xl-schedule>
                      </template>

                      <!--【联系人】【通话记录】【日程】线索、客户、商机 公共页签 E-->

                      <!--【分配记录】：线索S -->
                      <template v-if="item.value == 'allocationRecord' && userInfo?.orgId != huaYingOrdId">
                        <clue-allocation-records :moduleId="item.id"></clue-allocation-records>
                      </template>
                      <!-- 【分配记录】：线索E  【线索转化记录】：客户/商机有此页签S-->
                      <template v-if="item.value == 'transferRecord'">
                        <xl-clue-transform ref="clueRef"></xl-clue-transform>
                      </template>

                      <!-- 【线索转化记录】：客户/商机有此页签E -->
                      <!--【开票信息】【地址信息】【下级客户】【线索转化记录】：客户 S-->
                      <template v-if="item.value == 'invoice'">
                        <invoice-list :moduleId="item.id" ref="invoiceRef"></invoice-list>
                      </template>
                      <template v-if="item.value == 'address'">
                        <address-list :moduleId="item.id" ref="addressRef"></address-list>
                      </template>
                      <template v-if="item.value == 'lowerCustomer'">
                        <lower-customer ref="lowerCustomerRef"></lower-customer>
                      </template>

                      <!--【开票信息】【地址信息】【下级客户】【线索转化记录】：客户 E-->
                      <!--【业绩参与人】：商机S -->
                      <template v-if="item.value == 'partMan'">
                        <opportunity-performance ref="performanceRef"></opportunity-performance>
                      </template>
                      <!-- 【业绩参与人】：商机E -->
                      <!-- 【价格信息】：产品S -->
                      <template v-if="item.value == 'priceInfo'">
                        <component :moduleId="item.id" :is="priceInfo" v-if="item.value == 'priceInfo'"></component>
                      </template>
                      <!-- 【价格信息】：产品E -->

                      <!-- 【商机】【客户关键联系人】【客户特征】【客户伙伴数据（天维度）】 -->
                      <!-- ：售后服务S-->

                      <template v-if="item.value == 'customerLinkMan'">
                        <customer-contact :moduleId="item.id" ref="customerContactRef"></customer-contact>
                      </template>
                      <template v-if="item.value == 'feature'">
                        <customer-feature ref="customerFeatureRef"></customer-feature>
                      </template>
                      <template v-if="item.value == 'partner'">
                        <customer-partner-data ref="customerPartnerDataRef"></customer-partner-data>
                      </template>
                    </div>

                    <!--【商机】 【客户关键联系人】【客户特征】【客户伙伴数据（天维度）】：售后服务E-->
                    <template v-else>
                      <ly-skeleton v-if="data.tabLoading" fromType="field" :lineHeight="26" :row="8"></ly-skeleton>
                      <template v-else-if="data?.tabContentList?.length && data.initKey === index">
                        <fh-tab-page :record="data.tabContentList" :key="randomKey"></fh-tab-page>
                      </template>
                      <!-- <jw-spin v-else-if="data.loading" :tip="$t('数据加载中') + '……'" class="spin-loading"> </jw-spin> -->
                      <jw-empty class="empty-height" v-else :img-src="imgSvg"></jw-empty>
                    </template>
                  </jw-tab-pane>
                </jw-tabs>
              </jw-card>
            </div>
            <div :class="['side-detail', !expandCollapse ? 'side-detail-active' : '']" v-if="showRightPart">
              <template v-if="collaboratorIsShow == 1">
                <!-- 协作人 -->
                <xl-cooperation :moduleId="collaboratorId"></xl-cooperation>
              </template>
              <jw-card :bordered="false" :class="['log-item', collaboratorIsShow == 1 ? 'layout-follow-record-area-is-collaborator' : 'layout-follow-record-area-no-collaborator']">
                <!-- 动态记录组件 -->
                <jw-tabs class="log-tabs" style="height: 100%" destroy-on-hide :active-key="data.tabKey" @change="tabKeyChange">
                  <jw-tab-pane key="dynamicRecord" title="动态记录" v-if="showRecordTab">
                    <xl-record :moduleId="followRecordId" :layoutId="data.layoutId" ref="followRef" @cb="calenderUpdate"></xl-record>
                  </jw-tab-pane>
                  <jw-tab-pane key="dataLog" title="数据日志">
                    <xl-operation-log ref="xlOperationModule" :entityId="data.entity" :businessId="data.id" v-if="data.tabKey == 'dataLog'" />
                  </jw-tab-pane>
                </jw-tabs>
              </jw-card>
            </div>
          </div>
        </template>
        <div v-else class="no-detail">
          <jw-space direction="vertical" fill>
            <template v-if="errCodeStatus === 'ERR_CANCELED' || initLoading">
              <jw-spin :tip="$t('加载中') + '……'" />
            </template>
            <template v-else-if="errCodeStatus >= 500 || errCodeStatus === 0">
              <jw-spin :tip="$t('加载中') + '……'" />
              <jw-button type="outline" size="small" @click="init" class="no-detail-close">{{ $t('刷新') }}</jw-button>
            </template>
            <template v-else>
              <img :src="noPermission" alt="" class="no-detail-img" />
              <span>{{ isDeleted ? $t('已删除') : $t('暂无查看权限') }}</span>
              <jw-button type="outline" size="small" @click="handleCancel" class="no-detail-close">{{ $t('关闭') }}</jw-button>
            </template>
          </jw-space>
        </div>
      </div>
    </jw-drawer>
  </div>

  <object-setting-detail ref="layoutDetailRef" :entity="data.entity" @cb="init"></object-setting-detail>
</template>

<script setup>
import { reactive, inject, ref, computed, provide } from 'vue';
import { Message } from '@arco-design/web-vue';
import { layoutService } from '@/api/';
import imgSvg from '@/assets/images/img-no-record.svg';
// import CONFIG from '@/config/config';
import { useRoute, useRouter } from 'vue-router';
import noPermission from '@/assets/images/no-permission.svg';
import ClueAllocationRecords from '@/views/leads/components/clue-allocation-records/index.vue'; //线索分配记录
import approveRecord from '@/components/approve-record/approve-record.vue'; //审批记录
import invoiceList from '@/views/client/components/invoice-list/index.vue'; // 发票信息
import addressList from '@/views/client/components/address-list/index.vue'; //地址信息
import LowerCustomer from '@/views/client/components/lower-customer/index.vue'; //下级客户
import opportunityPerformance from '@/views/opportunity/components/opportunity-performance/index.vue'; //业绩参与人
import OpportunityStage from '@/views/opportunity/components/opportunity-stage/index.vue'; //商机阶段
import priceInfo from '@/views/product/components/product-price-info/index.vue'; //价格信息
import customerContact from '@/views/sales-service/components/customer-contact/index.vue'; //【客户关键联系人】
import customerFeature from '@/views/sales-service/components/customer-feature/index.vue'; //【客户特征】
import customerPartnerData from '@/views/sales-service/components/customer-partner-data/index.vue'; //【客户伙伴数据（天维度）】
import MainTitle from '@/components/fh-detail/components/main-title/index.vue'; //主标题
import useViewFields from '@/hooks/view-fields';
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/store';
import { huaYingOrdId, zhiShuOrgViewId, zhiShuOrgViewIds, zhiShuOrgId, hyzbOrgViewIds, hyzbOrgId, computingStatus } from '@/utils/const';
import useDetailDrawer from '@/hooks/drawer';
import useEventListener from '@/hooks/event-listener';
import objectSettingDetail from '@/views/setting/sys-fields/components/object-setting-detail/object-setting-detail.vue';
import AbstractSkeleton from '@/components/fh-detail/components/abstract-skeleton/index.vue';
import { useComputedStatusPollingCore } from '@/hooks/ly-table-config';
// 使用核心轮询功能
const { pollById } = useComputedStatusPollingCore({ entity: inject('globalParams')?.entity || inject('defaultParams').entity });
// 是否有遮罩props
defineProps({
  mask: {
    type: Boolean
  },
  id: {
    type: [String, Number],
    default: ''
    // 详情组件的业务ID，用于标识当前查看的详情记录
  },
  entity: {
    type: [String, Number],
    default: ''
  }
});
const { getLayoutDetailConfigArea, layoutMainField, layoutDetailAllList, layoutDetailConfig, layoutDetailLoading, setLayoutLoadingStatus, logicRolePermission, layoutAllFields, getEditLayoutConfig, layoutDetailModules, splitType } = useViewFields();
const route = useRoute();
const router = useRouter();
const routerBusinessId = route.params?.id; //路由参数
const { t } = useI18n();
const emits = defineEmits(['cb']);
const { userInfo } = useUserStore(); //用户信息
const { drawerVisible, setDrawerVisible, closeDialog } = useDetailDrawer();
const { eventListener } = useEventListener();
const data = reactive({
  // 以下是抽屉
  visible: drawerVisible,
  drawerWidth: '75%',
  smallLoading: false,
  id: inject('globalParams')?.id || inject('defaultParams')?.id || routerBusinessId, //路由参数id
  isFullscreen: false, //是否全屏
  addEdit: 'edit',
  tabValueList: [],
  //   fieldList: inject('defaultParams').fieldList, //表头
  entity: inject('globalParams')?.entity || inject('defaultParams').entity,
  globalEntity: inject('globalParams')?.entity,
  viewId: inject('globalParams')?.viewId === -1 ? '' : inject('defaultParams')?.viewId ? inject('defaultParams').viewId : '', //视图ID
  status: '',
  locked: false,
  customerId: null, //客户id
  customerName: '', //客户名称
  followUserId: null, //跟进人ID
  qccId: '',
  isDealt: '',
  // customerSize: null, //客户规模
  // intentionality: null, //跟进建议
  permission: logicRolePermission,
  loading: false,
  record: [],
  abstractList: [],
  tabList: [],
  tabContentList: [],
  detailsTitle: '',
  layoutId: '',
  initKey: 0, //页签区的key
  tabKey: 'dynamicRecord', //右侧区域key
  detailAllFields: [], //详情中所有字段信息
  layoutMainField: {}, //详情对象主属性字段信息
  poolId: '',
  listEntity: undefined, // 这个参数是表明从哪个列表打开详情
  historyPriceId: '', //报价单
  tagColors: {
    1: '#168cff',
    2: '#FF7D00',
    3: '#0fc6c2',
    4: '#FF7D00',
    6: '#00b42a',
    8: '#eb0aa4',
    10: '#4D8BB4',
    12: '#0fc6c2',
    13: '#0fc6c2',
    101: '#168cff'
  },
  abstractLoading: true,
  tabLoading: true,
  refreshStatus: false
});
const defaultActive = ref();
// const flowStageIsShow = ref();
const collaboratorIsShow = ref(null);
const collaboratorId = ref(null);
const followRecordIsShow = ref(null);
const followRecordId = ref(null);
const opStageRef = ref(); //商机阶段
const followRef = ref(); //动态记录
const calendarTripRef = ref(); //日程
const flowStageRef = ref(); // 流程阶段
const errCodeStatus = ref();
const initLoading = ref(true);
const drawerRef = ref(null); //详情抽屉
const xlOperationModule = ref(); // 数据日志模块
const computedError = ref(); // 计算字段错误信息
//布局详情会拿到一个数组：type=240摘要区，type=250页签区，type=260流程阶段(目前只有商机有此阶段)，type=270协作人，type=280动态记录
const randomKey = ref(0);
const layoutDetailRef = ref(null);

// 获取当前对象名称
const objectTitle = computed(() => {
  const layoutType220 = data.record?.find((v) => v.type === '220');
  return layoutType220?.label || '';
});

// 是否显示计算状态图标
const computedErrorStatus = computed(() => {
  const errorInfo = computedError.value?.[0] || '';
  return computingStatus.includes(errorInfo?.status);
});

// 计算状态tooltip内容
const computedErrorTooltipContent = computed(() => {
  const errorInfo = computedError.value?.[0] || '';
  return errorInfo?.status === 1 ? t('计算处理中') : errorInfo?.status === 3 ? t('审批处理中') : '';
});

// 是否显示右侧部分
const showRightPart = computed(() => {
  return collaboratorIsShow.value == 1 || [1, 2].includes(followRecordIsShow.value);
});
const showTabPart = (value) => {
  const tabValueList = ['approvalRecord', 'cloud', 'linkMan', 'callRecord', 'schedule', 'allocationRecord', 'transferRecord', 'invoice', 'address', 'lowerCustomer', 'partMan', 'priceInfo', 'customerLinkMan', 'feature', 'partner'];
  return tabValueList.includes(value);
};
// 切换tabs
const changeTab = (key) => {
  defaultActive.value = key;
  const _findIndex = data.tabList.modules?.findIndex((m) => m?.id == key);
  if (_findIndex > -1) switchTabs(_findIndex);
};
const switchTabs = async (key) => {
  randomKey.value++;
  data.tabLoading = true;
  setRefreshStatus(false); //设置刷新状态
  data.tabContentList = [];
  data.initKey = key;
  // 所有系统页签（tab页签有value值）不再调用接口（data.tabList.modules[key].value）
  if (data.tabList.modules[key].value) return;
  await getLayoutDetailModule(data.tabValueList?.[key], 2);
};
// 接收头部组件传参
const toggleScreen = (isFullscreen) => {
  console.log('toggleScreen', isFullscreen);
  if (isFullscreen == false) {
    data.drawerWidth = data.entity == 4 ? '60%' : '75%';
  } else {
    data.drawerWidth = '100%';
  }
  flowStageRef?.value?.refreshKeyUpdate();
};

const openDetailConfig = () => {
  const params = {
    id: data.layoutId,
    operationType: 0, //操作类型 1：新建 0：编辑2：复制
    saveCopyType: null,
    splitType: splitType.value // 分裂模式 2 未分裂、 3 分裂
  };
  layoutDetailRef?.value.openDialog(params);
};
// 头部组件回传的事件
const handleHeaderCb = async (params) => {
  console.log(305, params);
  if (params.type === 1) {
    // 切换全屏
    toggleScreen(params.hp);
  } else if (params.type === 2) {
    // 关闭弹窗
    handleCancel();
  } else if (params.type === 3) {
    // 刷新详情
    await init();
    data.initKey = params.hp;
  } else if (params.type === 4) {
    // 打开详情页面配置
    openDetailConfig();
  }
};
// 右侧tab切换
const tabKeyChange = (key) => {
  data.tabKey = key;
};
// 抽屉详情之取消按钮
const handleCancel = () => {
  // data.visible = false;
  unObserver(); //卸载观察器
  setDrawerVisible(false);
  emits('cb'); //刷新列表
  if (data.globalEntity) return;
  //   console.log("globalEntity---",data.globalEntity)
  //   if (data.entity == 1) {
  //     router.push({ name: 'leads-list' });
  //   } else
  if (data.entity == 2) {
    // 智书3租户定制需求 S
    if (userInfo.orgId === zhiShuOrgId && zhiShuOrgViewIds.includes(data.viewId)) {
      router.push({ name: 'customer-sales-list' });
    }
    // 智书3租户定制需求 E
  }

  // 这里是学冬让做的 仅针对华映385租户 特殊逻辑 s
  if (data.entity == 1) {
    if (userInfo.orgId === hyzbOrgId && hyzbOrgViewIds.includes(data.viewId)) {
      router.push({ name: 'hy-leads-list' });
    }
  }
  // 这里是学冬让做的 仅针对华映385租户 特殊逻辑 E
};

// Handle ESC key to close drawer
const handleEscKey = (event) => {
  // Check if ESC key is pressed and drawer is visible
  if ((event.key === 'Escape' || event.keyCode === 27) && drawerVisible.value) {
    handleCancel();
    event.stopPropagation(); // Prevent event bubbling
  }
};

// Register ESC key listener
eventListener('keydown', handleEscKey, window, true);

// 更新页签区的数据
const updateTabContent = (result) => {
  const resultById = new Map();
  result?.forEach((item) => {
    resultById.set(item.id, item.modules);
  });
  data.tabContentList?.forEach((el) => {
    const modules = resultById.get(el.id);
    if (modules) {
      el.modules = modules;
    }
  });
};
const allButtonsList = ref([]);
// 获取布局详情当前布局数据
const getLayoutDetailModule = async (moduleId, type) => {
  if (!moduleId) return;
  if (!data.refreshStatus) {
    //代表是初始化
    if (type === 1) {
      data.abstractLoading = true;
    } else if (type === 2) {
      data.tabLoading = true;
    }
  }

  try {
    const params = {
      entity: data.entity,
      moduleId: moduleId,
      businessId: data.entity == 6 && data.historyPriceId ? data.historyPriceId : data.id
    };
    // data.loading = true;
    const json = await layoutService.getDetail(params);
    if (!json.error) {
      if (type === 0) {
        //标题区
        if (json.result && json.result?.length) {
          data.detailsTitle = json.result?.find((v) => v.type === '20')?.fieldValue || '';
          allButtonsList.value = json.result?.filter((v) => v.type !== '20');
        }
      } else if (type === 1) {
        // 摘取区
        data.abstractLoading = false;
        data.abstractList = json.result?.filter((v) => v.type === '20');
      } else if (type === 2) {
        //  页签区
        data.tabLoading = false;
        if (!data.refreshStatus) {
          //代表是初始化
          data.tabContentList = json.result;
        } else {
          //代表是刷新
          updateTabContent(json.result);
        }
      }
      // data.loading = false;
    } else {
      // data.loading = false;
      Message.error(json.error?.msg || t('数据获取失败'));
      data.tabContentList = [];
    }
  } catch (e) {
    console.log(e);
    data.tabContentList = [];
  }
};

const scrollPosition = ref(0);

// 批量更新详情重复数据
const refreshValue = () => {
  const drawerRef = document.querySelector('.arco-drawer-body');
  scrollPosition.value = drawerRef.scrollTop;
  detailRefresh(scrollPosition.value);
};

//删除资料沉淀导致刷新商机阶段
const updateStage = () => {
  if (data.entity == 3) {
    opStageRef.value?.getEntityStage();
  }
};
//从日程添加动态记录之后刷新动态记录列表
const refreshFollowList = () => {
  followRef.value.loadTList();
};
//动态记录刷新日程列表
const calenderUpdate = async () => {
  calendarTripRef.value?.[0]?.getCalenderDetail();
};

// 获取计算字段错误信息
const isComputedRequested = ref(false); //计算字段接口是否请求完成
// const computedErrorLog = async () => {
//   try {
//     const json = await setService.getComputedErrorLog({
//       entity: data.entity,
//       businessIdList: [data.id]
//     });
//     if (!json.error) {
//       //只有请求接口成功获取数据才标识成功，接口异常或请求失败不显示按钮信息2025年08月01日10:52:05 zl 产品雳勐
//       isComputedRequested.value = true;
//       computedError.value = json.result;
//     }
//   } catch (e) {
//     console.log(e);
//   }
// };
// 设置刷新状态
const setRefreshStatus = (status) => {
  data.refreshStatus = status;
};

// 该方法仅用于商机详情、及当前激活tab页的接口和头部摘要区接口
const detailRefresh = async () => {
  // eslint-disable-next-line no-debugger
  // debugger;
  data.smallLoading = true;
  setRefreshStatus(true);
  try {
    const res = await layoutService.getLayoutDetailModules({
      entity: data.entity,
      viewId: data.viewId,
      businessId: data.id
    });
    if (!res.error) {
      const detailList = res.result.modules;
      ruleFields.value = res?.result?.data?.PERMISSION || {};
      computedError.value = [res?.result?.data?.computedInfo];
      if (data.entity == 2) {
        data.qccId = res?.result?.data?.qccId;
      }

      //标题区
      const detailTitleId = detailList.find((v) => v.type === '220');

      if (detailTitleId && detailTitleId?.id) {
        await getLayoutDetailModule(detailTitleId?.id, 0);
      }
      // 摘取区
      const getAbstractId = detailList.find((v) => v.type === '240')?.id || '';
      if (getAbstractId) {
        await getLayoutDetailModule(getAbstractId, 1);
      }
      //  页签区
      if (data.tabList?.modules?.length && Object.keys(data.tabValueList)?.length > 0 && data.tabValueList?.[data.initKey]) {
        await getLayoutDetailModule(data.tabValueList?.[data.initKey], 2);
      }
    }
    // 流程阶段
    if (flowStageRef.value) {
      flowStageRef.value?.getNodeTableListByNodeId();
    }
    // 数据日志
    if (xlOperationModule.value && data.tabKey == 'dataLog') {
      xlOperationModule.value.outFresh();
    }

    data.smallLoading = false;
    pollById(data.id, { onComplete });
  } catch (e) {
    console.log(265, e);
    data.smallLoading = false;
    // setRefreshStatus(false)
    return { type: 3, res: e };
  }
  // setRefreshStatus(false)
};
// 单字段编辑成功之后 刷新该字段
const updateFieldValue = (items, fieldKey, fieldValue) => {
  items?.forEach((item) => {
    if (item?.setting?.fieldKey === fieldKey) {
      item.fieldValue = fieldValue;
    }
  });
};
const refreshFieldValue = (callbackObj) => {
  updateFieldValue(data.abstractList, callbackObj.fieldKey, callbackObj.fieldValue);

  data.tabContentList?.forEach((tab) => {
    updateFieldValue(tab?.modules, callbackObj.fieldKey, callbackObj.fieldValue);
  });
};

let observer = null;
const showHeadTitle = ref(false);
const mainTitleRef = ref(null); // 主属性ref

// 注册观察器
const initObserver = () => {
  observer = new IntersectionObserver(
    ([entry]) => {
      // entry.isIntersecting 为 true 表示 主属性组件 在视口中
      showHeadTitle.value = !entry.isIntersecting;
    },
    {
      root: null, // 观察相对视口
      threshold: 0 // 只要有一像素进入或离开就触发
    }
  );
  if (mainTitleRef.value) {
    observer.observe(mainTitleRef.value);
  }
};

//卸载观察器
const unObserver = () => {
  if (observer && mainTitleRef.value) {
    console.log('卸载观察器');
    observer.unobserve(mainTitleRef.value);
  }
};

// 打开弹窗
const openDialog = async (listEntity) => {
  // observer?.disconnect();
  // showHeadTitle.value = false; // 切换中保持隐藏
  data.initKey = 0;
  isComputedRequested.value = false;
  setRefreshStatus(false); //设置刷新状态
  initLoading.value = true; //设置默认加载状态
  defaultActive.value = null;
  console.log(359, 'listEntity', listEntity);
  if (data.entity == 6) {
    data.historyPriceId = '';
  }
  if (data.entity == 2) {
    data.listEntity = listEntity || undefined;
  }
  if (data.entity == 4) {
    data.drawerWidth = '60%';
  } else {
    data.drawerWidth = '75%';
  }
  setDrawerVisible(true);

  await init();
  //展开收起
  // initObserver(); // 重新观察

  if (showRightPart.value) {
    //有右侧部分
    expandCollapse.value = getlocalExpandStatus();
  } else {
    expandCollapse.value = false;
  }
};

// 关闭弹窗
// const closeDialog = async () => {
//   data.visible = false;
// };
const updateData = ref([]);
const getUpdateData = async () => {
  await getEditLayoutConfig({
    viewId: data.viewId,
    businessId: data.id,
    entity: data.entity
  });
  updateData.value = layoutDetailModules?.value[0]?.modules || [];
  console.log(updateData.value);
};
const buttonNumber = ref(0);
const showRecordTab = ref(false);
const ruleFields = ref({});

const onComplete = () => {
  if (computedError.value?.[0]?.status && computingStatus.includes(computedError.value?.[0]?.status)) {
    detailRefresh();
  }
};
const isDeleted = ref(false);
const init = async (tp) => {
  observer?.disconnect();
  showHeadTitle.value = false; // 切换中保持隐藏
  data.detailsTitle = '';
  data.record = [];
  data.tabContentList = [];
  data.abstractList = [];
  data.tabList = [];
  data.abstractLoading = true;
  data.tabLoading = true;
  setRefreshStatus(false);
  //历史报价跳转传id
  if (data.entity == 6 && tp) {
    data.historyPriceId = tp;
  }
  // 如果是false，则不显示loading
  if (tp === false) {
    setLayoutLoadingStatus(tp);
  }
  // 租户3的特殊逻辑  -s-
  if (userInfo.orgId === zhiShuOrgId && (data?.listEntity == 12 || data?.listEntity == 204)) {
    data.viewId = zhiShuOrgViewId;
  }
  // 获取详情页面模块配置
  const resDetail = await getLayoutDetailConfigArea({
    entity: data.entity,
    viewId: data.viewId,
    businessId: data.entity == 6 && tp ? tp : data.id
  });

  isDeleted.value = layoutAllFields.value?.isDeleted || false;
  ruleFields.value = layoutAllFields.value?.PERMISSION || {};

  // resDetail.type == 2代表接口出错了,>=500代表服务端错误，等于ERR_CANCELED代表接口取消
  if (resDetail.type == 2) {
    errCodeStatus.value = resDetail.res.error.code;
  } else if (resDetail.type == 3) {
    errCodeStatus.value = resDetail.res.errCode;
  }
  initLoading.value = false; //清空默认加载状态
  data.record = layoutDetailAllList; //布局模块list

  data.layoutId = data.record?.[0]?.layoutId;
  // 获取详情中所有字段信息

  data.detailAllFields = layoutAllFields;
  data.layoutMainField = layoutMainField;

  computedError.value = [layoutAllFields.value?.computedInfo];
  isComputedRequested.value = true;
  /*** 客户需要S** */
  if (data.entity == 2) {
    data.customerId = data.detailAllFields?.id;
    data.customerName = data.detailAllFields?.customerName;
    data.qccId = data.detailAllFields?.qccId;
    data.isDealt = data.detailAllFields?.isDealt;
  }
  /*** 客户需要E** */
  data.followUserId = data.detailAllFields?.followUser;
  if (data.entity != 2) {
    data.customerId = data.detailAllFields?.customerId?.value;
  }
  if (data.entity == 101) {
    data.poolId = data.detailAllFields?.cluePoolId;
  }

  // data.customerSize = data.detailAllFields?.size;
  // data.intentionality = data.detailAllFields?.intentionality;
  data.status = data.detailAllFields?.status;
  data.locked = data.detailAllFields?.locked;
  // tag标签区
  const detailTitleId = data.record?.find((v) => v.type === '220');
  buttonNumber.value = detailTitleId?.businessData ?? 2; //外层默认显示按钮数
  const getAbstractId = data.record?.find((v) => v.type === '240')?.id || '';
  data.tabList = data.record?.find((v) => v.type === '250');
  // 流程阶段是否展示
  if (data.entity == 2 || data.entity == 3) {
    // flowStageIsShow.value = data.record?.find((v) => v.type === '230')?.display;
    if (data.detailAllFields?.hasOppStage) {
      //如果商机阶段存在,获取商机阶段反显字段
      getUpdateData();
    }
  }
  // 协作人是否展示
  const _collaborator = data.record?.find((v) => v.type === '270');
  collaboratorIsShow.value = _collaborator?.display;
  collaboratorId.value = _collaborator?.id;
  // 动态记录是否展示
  const _followRecord = data.record?.find((v) => v.type === '280');
  followRecordIsShow.value = _followRecord?.display;
  followRecordId.value = _followRecord?.id;

  // 是否展示动态记录
  if ((followRecordIsShow.value == 1 || followRecordIsShow.value == 2) && userInfo?.roles?.indexOf('dynamicRecord:view') !== -1) {
    showRecordTab.value = true;
    data.tabKey = 'dynamicRecord';
  } else {
    showRecordTab.value = false;
    data.tabKey = 'dataLog';
  }
  //标题区
  if (detailTitleId && detailTitleId?.id) {
    await getLayoutDetailModule(detailTitleId?.id, 0);
  }
  // 摘要区
  if (getAbstractId) {
    await getLayoutDetailModule(getAbstractId, 1);
  }
  // 页签区
  if (data.tabList?.modules?.length) {
    data.tabValueList = data.tabList.modules.map((v) => v.id);
    console.log(452, data.tabValueList);
    await getLayoutDetailModule(data.tabValueList?.[data.initKey], 2);
  }
  //获取计算字段错误信息
  // await computedErrorLog();
  data.abstractLoading = false;
  data.tabLoading = false;
  // 初始化获取完计算状态之后 调用 轮询
  pollById(data.id, { onComplete });
  initObserver(); // 重新观察
};
// 动态记录导致刷新摘要区和页签区数据
const updateAbstract = async () => {
  setRefreshStatus(true); //更新刷新状态
  // 判断摘要区 最近跟进内容 最近跟进时间 字段 是否存在
  const abstractLastFollow = data.abstractList?.length && data.abstractList?.filter((item) => item.value == 'lastFollowContent' || item.value == 'lastFollowTime')?.length;
  // 判断页签区 最近跟进内容 最近跟进时间 字段 是否存在
  let tabContentListFollow = false;
  data.tabContentList?.forEach((item) => {
    if (item?.modules && item?.modules?.length) {
      item?.modules?.forEach((i) => {
        if (i.value == 'lastFollowContent' || i.value == 'lastFollowTime') {
          tabContentListFollow = true;
        }
      });
    }
  });
  if (abstractLastFollow || tabContentListFollow) {
    // 摘要区
    data.record = layoutDetailAllList; //布局模块list
    const getAbstractId = data.record?.find((v) => v.type === '240')?.id || '';
    if (getAbstractId) {
      await getLayoutDetailModule(getAbstractId, 1);
    }
    // 更新页签区
    if (data.tabList?.modules?.length && Object.keys(data.tabValueList)?.length > 0 && data.tabValueList?.[data.initKey]) {
      await getLayoutDetailModule(data.tabValueList?.[data.initKey], 2);
    }
  }
};

// 按钮组件的事件
const buttonsEvent = (type, params) => {
  if (type === 'handleCancel') {
    handleCancel();
  } else if (type === 'init') {
    init(params);
  }
};
const getlocalExpandStatus = () => {
  return localStorage.getItem('expandCollapse') == 'true' ? true : localStorage.getItem('expandCollapse') == 'false' ? false : true;
};
const expandCollapse = ref(getlocalExpandStatus()); //默认展开

const handleExpand = () => {
  expandCollapse.value = !expandCollapse.value;
  flowStageRef?.value?.refreshKeyUpdate();
  localStorage.setItem('expandCollapse', expandCollapse.value);
};
provide('detailParams', {
  id: computed(() => (data.entity == 6 && data.historyPriceId ? data.historyPriceId : data.id)),
  record: computed(() => data.record), //列表数据
  entity: computed(() => data.entity),
  status: computed(() => data.status),
  permission: computed(() => data.permission), //权限
  followUserId: computed(() => data.followUserId),
  customerId: computed(() => data.customerId),
  updateData: computed(() => updateData.value), //给审批反显字段使用
  customerName: computed(() => data.customerName),
  detailsTitle: computed(() => data.detailsTitle),
  computedError: computed(() => computedError.value), // 计算字段错误信息
  qccId: computed(() => data.qccId),
  detailAllFields: computed(() => data.detailAllFields),
  layoutMainField: computed(() => data.layoutMainField),
  poolId: computed(() => data.poolId),
  viewId: computed(() => data.viewId),
  historyPriceId: computed(() => data.historyPriceId),
  locked: computed(() => data.locked),
  refreshStatus: computed(() => data.refreshStatus),
  ruleFields: computed(() => ruleFields.value), //规则匹配字段列表【Object】
  refreshValue: refreshValue,
  updateAbstract: updateAbstract,
  drawerRef: drawerRef,
  detailRefresh: detailRefresh,
  refreshFieldValue: refreshFieldValue,
  expandCollapse: computed(() => expandCollapse.value), //展开收起变量
  showRightPart: computed(() => showRightPart.value), //是否展示右侧部分
  layoutDetailConfig: computed(() => layoutDetailConfig.value) //详情配置
});

defineExpose({ openDialog, closeDialog });
</script>
<style scoped lang="less">
@import './index.less';
</style>
<style lang="less">
.obj-details-drawer {
  .arco-drawer {
    .arco-drawer-body {
      padding: 0 !important;
    }
  }

  .layout-card-header {
    border-radius: 0;
  }
}
</style>
